/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BatchPermissionViewModel } from "../types/BatchPermissionViewModel.ts";

export const batchPermissionViewModelSchema = z.object({
  controllerId: z.optional(
    z
      .number()
      .int()
      .describe("ID do controller ao qual a permissão se aplica."),
  ),
  roleId: z.optional(
    z
      .number()
      .int()
      .describe(
        "Perfil do usuário ao qual a permissão será atribuída. Enum EUserRole: `1` = Master, `2` = Administrator, `3` = Polo, `4` = Basic, `5` = Relationship, `6` = Planning, `7` = Secretary, `8` = Communication, `9` = Financial, `10` = Visitor, `11` = API, `12` = StudentCare, `13` = Valoriza, `14` = Leads, `15` = Faculty, `16` = Orientation, `17` = Exams, `18` = BusinessCore, `19` = Contracts, `20` = HumanResources, `21` = Audiovisual, `22` = ScholarshipTeam, `23` = Translation, `24` = Transmission, `25` = RelationshipTR, `26` = International.",
      ),
  ),
  canRead: z.optional(
    z.boolean().describe("Define se o perfil possui permissão de leitura."),
  ),
  canCreate: z.optional(
    z.boolean().describe("Define se o perfil possui permissão de criação."),
  ),
  canUpdate: z.optional(
    z.boolean().describe("Define se o perfil possui permissão de edição."),
  ),
  canDelete: z.optional(
    z.boolean().describe("Define se o perfil possui permissão de exclusão."),
  ),
}) as unknown as ToZod<BatchPermissionViewModel>;
